import { jsxs, jsx } from "react/jsx-runtime";
const IconRocketSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M21.7 3.66c-.17-.67-.71-1.21-1.38-1.38-4.44-1.12-8.54 1.29-10.87 3.82l-4.1.19c-.25.01-.48.12-.66.29L1.36 9.91c-.22.22-.32.52-.29.82.04.3.21.57.47.73l3.39 2.1 5.49 5.49 2.1 3.4c.16.26.43.43.74.47h.12c.26 0 .52-.1.71-.29l3.33-3.33c.18-.18.28-.41.29-.66l.19-4.13c2.53-2.33 4.92-6.42 3.8-10.86Zm-11.06 4.1c1.78-2.11 5.05-4.25 8.58-3.67.33.05.61.33.66.66.58 3.54-1.56 6.8-3.67 8.58-1.07.91-3.48 2.67-4.86 3.66l-4.38-4.38c.81-1.12 2.69-3.71 3.66-4.86Zm-6.98 2.67 2.16-2.16 1.94-.09c-.91 1.2-1.9 2.57-2.42 3.29l-1.68-1.04Zm9.9 9.9-1.05-1.7c1.03-.74 2.26-1.64 3.3-2.43l-.09 1.97-2.16 2.16Z" }),
      /* @__PURE__ */ jsx("path", { d: "M16.19 10.61c.78-.78.78-2.05 0-2.83-.78-.78-2.05-.78-2.83 0-.78.78-.78 2.05 0 2.83.78.78 2.05.78 2.83 0Zm-9.33 6.5a.996.996 0 0 0-1.41 0l-2.32 2.32a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.32-2.32a.996.996 0 0 0 0-1.41Zm-3.24-.3.76-.76c.39-.39.39-1.02 0-1.42-.39-.39-1.02-.39-1.42 0l-.76.76c-.39.39-.39 1.02 0 1.42.2.2.45.29.71.29s.51-.1.71-.29Zm4.3 2.78-.76.76a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l.76-.76a.996.996 0 1 0-1.41-1.41Z" })
    ]
  }
);
export {
  IconRocketSvg
};
